import { inject, Injectable } from '@angular/core';
import { PolicyTokensAccessor } from '@benefitsui/app/lib/policy/policy-token/policy-token-accessor.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  policyTokenAccessor = inject(PolicyTokensAccessor);

  get token() {
    return this.policyTokenAccessor.get().value.join(',');
  }

  hasMiddleName(input?: string) {
    if (input && input !== '') {
      return true;
    } else return false;
  }

  formatFullName(first?: string, middle?: string, last?: string) {
    const hasMiddleName = this.hasMiddleName(middle);

    if (hasMiddleName) {
      return `${first} ` + `${middle?.[0]} ` + `${last}`;
    } else {
      return `${first} ${last}`;
    }
  }
}
